<div class="div-title">
  <h1 mat-dialog-title>
    {{ data.title }}
  </h1>
</div>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div class="div-buttons" mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-button mat-raised-button color="{{data.colorConfirmButton}}" (click)="onConfirm()">{{ data.confirmButton
    }}</button>
</div>